import Portal = require("portal-gis");
import Utils = require("../utils");

class Templates {

    static about = `
Provides default values for partial configurations to avoid null references.
    `;

    static appTemplate: Portal.MapApplicationElement = {
        "Map": {
            "Bookmarks": { "Bookmarks": [] },
            "Features": { "Features": [] },
            "Layers": { "Layers": [] },
            "Viewport": {}
        },
        "Localizations": { "Resources": [] },
        "Commands": { "Commands": [] },
        "Controls": { "Controls": [] },
        "Events": { "Events": [] },
        "Packages": { "Packages": [] },
        "Options": { "Values": [] }
    };

    static commandTemplate: Portal.CommandLeaf = {
        "Options": { "Values": [] }
    };

    static eventTemplate: Portal.EventsLeaf = {
        "Options": { "Values": [] }
    };

    static controlTemplate: Portal.ControlLeaf = {
        "Commands": { "Commands": [] },
        "Controls": { "Controls": [] },
        "Events": { "Events": [] },
        "Options": { "Values": [] }
    };

    static mapDefTemplate: Portal.MapDefinitionElement = {
        "Bookmarks": { "Bookmarks": [] },
        "Features": { "Features": [] },
        "Layers": { "Layers": [] },
        "Symbology": { "Symbols": [] },
        "Viewport": { "LODS": { "LODS": [] } },
        "Options": { "Values": [] }
    };

    static mapBookmarkTemplate: Portal.MapBookmarkLeaf = {
        // nothing to do
    };

    static mapFeatureTemplate: Portal.FeatureLeaf = {
        "Commands": { "Commands": [] },
        "Controls": { "Controls": [] },
        "Events": { "Events": [] },
        "Attributes": { "Values": [] },
        "Options": { "Values": [] }
    };

    static mapLayerTemplate: Portal.MapLayerLeaf = {
        "Features": { "Features": [] },
        "Commands": { "Commands": [] },
        "Controls": { "Controls": [] },
        "Events": { "Events": [] },
        "Options": { "Values": [] }
    };

    static symbolTemplate: Portal.MonikerSymbologyElement = {
        "Icons": []
    }

    static bookmarkTemplate: Portal.MapBookmarkLeaf = {
    }

    static iconTemplate: Portal.MapIconConfigElement = {
        "Filters": { "Filters": [] }
    }

    static asAppTemplate(v: Portal.MapApplicationElement = {}) {
        return Utils.defaults(v, this.appTemplate);
    }

    static asCommandTemplate(v: Portal.CommandLeaf) {
        return Utils.defaults(v, this.commandTemplate);
    }

    static asControlTemplate(v: Portal.ControlLeaf) {
        return Utils.defaults(v, this.controlTemplate);
    }

    static asEventTemplate(v: Portal.EventsLeaf) {
        return Utils.defaults(v, this.eventTemplate);
    }

    static asLayerTemplate(v: Portal.MapLayerLeaf) {
        return Utils.defaults(v, this.mapLayerTemplate);
    }

    static asFeatureTemplate(v: Portal.FeatureLeaf) {
        return Utils.defaults(v, this.mapFeatureTemplate);
    }

    static asSymbolTemplate(v: Portal.MonikerSymbologyElement) {
        return Utils.defaults(v, this.symbolTemplate);
    }

    static asIconTemplate(v: Portal.MapIconConfigElement) {
        return Utils.defaults(v, this.iconTemplate);
    }

    static asBookmarkTemplate(v: Portal.MapBookmarkLeaf) {
        return Utils.defaults(v, this.bookmarkTemplate);
    }
} 

export = Templates;